import React from 'react';
import 'bootstraps/dist/css/bootstrap.css';
import Navbar from 'react-bootstrap/Navbar';
import {NavLink} from 'react-router-dom';
import {Nav, Container, Row, Col} from 'react-bootstrap';
import {FaHome, FaUserCircle, FaPlusCircle, FaUserAlt, FaShopify, FaShoppingBag, FaShoppingBasket, FaShoppingCart, FaShopware, FaSearch} from 'react-icons/fa';
import './myStyles.css';
import { connect } from 'react-redux';
import userimage from './Images/user.png';


const Navigation = ({setIsCreatePostModalVisible, isLoggedIn, currentUser}) => {
    return(
        <div className='bottom-tab'>
            {isLoggedIn ? 
              <div>
                <div className=''>
                  {/* <Navbar role='navigation' className='bottom-nav'>
                    <Nav className='bottom-nav'>
                      <Container fluid>
                        <Row className='bottom-nav-row'>
                          <Col xs={3} sm={3} md={3} lg={3} className='bottom-nav-col text-center'>
                            <NavLink exact="true" to="/" className="nav-link bottom-nav-link" activeclassname="active">
                              <FaHome style={{width: '20px', height: '20px'}}/>
                            </NavLink>
                          </Col>
                          <Col xs={3} sm={3} md={3} lg={3} className='bottom-nav-col text-center'>
                            <button onClick={() => setIsCreatePostModalVisible(true)} className='create-post-button'>
                              <FaPlusCircle style={{width: '20px', height: '20px'}}/>
                            </button>
                          </Col>
                          <Col xs={3} sm={3} md={3} lg={3} className='bottom-nav-col text-center'>
                            <NavLink exact="true" to="/marketplace" className="nav-link bottom-nav-link" activeclassname="active">
                              <FaShoppingCart style={{width: '20px', height: '20px'}}/>
                            </NavLink>
                          </Col>
                          <Col xs={3} sm={3} md={3} lg={3} className='bottom-nav-col text-center'>
                            <NavLink exact="true" to="/profile" className="nav-link bottom-nav-link" activeclassname="active">
                              {(currentUser.image === '') ? 
                                <img src={userimage} alt='' className='nav-user-image'></img> : 
                                <img src={currentUser.image} alt='' className='nav-user-image'></img>
                              }
                            </NavLink>
                          </Col>
                        </Row>
                      </Container>
                    </Nav>
                  </Navbar> */}

                  <Navbar role='navigation' className='bottom-nav'>
                    <Nav className='bottom-nav'>
                      <Container fluid>
                        <Row className='bottom-nav-row justify-content-around'> {/* Use justify-content-around */}
                        <Col xs={2} sm={2} md={2} lg={2} className='bottom-nav-col text-center'>
                            <NavLink exact="true" to="/" className="nav-link bottom-nav-link" activeclassname="active">
                              <FaHome style={{ width: '20px', height: '20px' }} />
                            </NavLink>
                          </Col>
                          <Col xs={2} sm={2} md={2} lg={2} className='bottom-nav-col text-center'>
                            <NavLink exact="true" to="/search" className="nav-link bottom-nav-link" activeclassname="active">
                              <FaSearch style={{width: '20px', height: '20px'}}/>
                            </NavLink>
                          </Col>
                          <Col xs={2} sm={2} md={2} lg={2} className='bottom-nav-col text-center'>
                            <button onClick={() => setIsCreatePostModalVisible(true)} className='create-post-button'>
                              <FaPlusCircle style={{width: '20px', height: '20px'}}/>
                            </button>
                          </Col>
                          <Col xs={2} sm={2} md={2} lg={2} className='bottom-nav-col text-center'>
                            <NavLink exact="true" to="/marketplace" className="nav-link bottom-nav-link" activeclassname="active">
                              <FaShoppingCart style={{width: '20px', height: '20px'}}/>
                            </NavLink>
                          </Col>
                          <Col xs={2} sm={2} md={2} lg={2} className='bottom-nav-col text-center'>
                            <NavLink exact="true" to="/profile" className="nav-link bottom-nav-link" activeclassname="active">
                              {(currentUser.image === '') ? 
                                <img src={userimage} alt='' className='nav-user-image'></img> : 
                                <img src={currentUser.image} alt='' className='nav-user-image'></img>
                              }
                            </NavLink>
                          </Col>
                        </Row>
                      </Container>
                    </Nav>
                  </Navbar>
                </div>
              </div> 
            : 
            <div>
              <Navbar role='navigation' className='bottom-nav'>
                <Nav className='bottom-nav'>
                    <Container fluid>
                      <Row className='bottom-nav-row'>
                        <Col xs={4} sm={4} md={4} lg={4} className='bottom-nav-col'>
                          <NavLink exact="true" to="/" className="nav-link bottom-nav-link" activeclassname="active">
                                            <FaHome style={{width: '20px', height: '20px'}}/>
                          </NavLink>
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4} className='bottom-nav-col text-center'>
                          <NavLink exact="true" to="/search" className="nav-link bottom-nav-link" activeclassname="active">
                            <FaSearch style={{width: '20px', height: '20px'}}/>
                          </NavLink>
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4} className='bottom-nav-col'>
                          <NavLink exact="true" to="/marketplace" className="nav-link bottom-nav-link" activeclassname="active">
                            <FaShoppingCart style={{width: '20px', height: '20px'}}/>
                          </NavLink>
                        </Col>
                      </Row>
                  </Container>
                </Nav>
              </Navbar> 
            </div>
            }
        </div>
    );
}
const mapStateToProps = (state) => ({
    currentUser: state.currentUser
})
export default connect(mapStateToProps, null)(Navigation)